<template>
    <div class="modal fade custom-right-modal" id="quotationVendorMailModal" ref="quotationVendorMailModal">
        <div class="modal-dialog" style="max-width: 1140px !important;">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h5 class="modal-title">Vendors Mails</h5>
                    <button type="button" class="close" data-dismiss="modal"><i class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div class="history-d1" v-if="vendor_mails.length">
                        <Inbox :type="'vendor'" :messages="vendor_mails" :selected="vendor_mails[0]" :quotation="quotation"></Inbox>
                        <!--<div class="task-bg" v-for="(item, index) in vendor_mails">
                            <div class="small-heading">{{item.subject}}</div><p></p>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="light-clr"> Mail sent to {{item.vendor }} ({{item.contact}}) </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="pull-right light-clr">{{item.created_at}}</div>
                                </div>
                            </div>
                        </div>-->
                    </div>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import Inbox from "./Inbox";

export default {
    name: "QuotationVendorMailModal",
    props: ['quotation',],
    components: {Inbox},
    created() {

    },
    mounted() {
        $(this.$refs.quotationVendorMailModal).on('show.bs.modal', () => {
            this.getVendorMail();
        });
    },
    data() {
        return {
            vendor_mails: []
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        getVendorMail() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('get_vends');

            let payload = {quote_id: this.quotation.id};

            return axios.post(apiUrl, payload, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        this.vendor_mails = data.data;
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });

            /*let apiUrl = window.route('quotations.getVendorMail');

            return axios.post(apiUrl, {quote_id: this.quotation.id}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        this.vendor_mails = data.data.vendor_mail ? data.data.vendor_mail : [];
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });*/
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
